import React from 'react'
import { getChangedFieldsets, hasChangedValues, getFormValue } from 'tyan/public/utility'

class SpotItemSettingDiv extends React.Component {
    state = {
        id: this.props.id || 0,
        instrumentID: this.props.instrumentID || 0,
        readOnly: this.props.readOnly || false,
    }

    componentDidMount = () => {
        this.doGetSpotItem()
    }

    doGetSpotItem = () => {
        const { id, instrumentID } = this.state
        Tyan.doPostEvent('GetSpotItem', {
            data: { id, instrumentID },
            onEnd: ({ errorMessage, optionsParas, initValues基本信息 }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                } else {
                    this.setState({ optionsParas, initValues基本信息, changedValues基本信息: {} })
                }
            }
        })
    }

    handlerSave = () => {
        const { onClose, onRefresh } = this.props
        const { instrumentID } = this.state
        Tyan.doPostEvent('SaveSpotItem', {
            data: { instrumentID, ...getChangedFieldsets(this, '基本信息', false) },
            onEnd: ({ errorMessage }) => {
                if (errorMessage) {
                    Tyan.pubForm.showError(errorMessage)
                } else {
                    Ext.toast('保存成功')
                    onClose && onClose()
                    onRefresh && onRefresh()
                }
            }
        })
    }

    handlerDelete = () => {
        const { onClose, onRefresh } = this.props
        const { id } = this.state
        Tyan.pubForm.showConfirm('确定要删除？', () =>
            Tyan.doPostEvent('DelSpotItem', {
                data: { id },
                onEnd: ({ errorMessage }) => {
                    if (errorMessage) {
                        Tyan.pubForm.showError(errorMessage)
                    } else {
                        Ext.toast('删除成功')
                        onClose && onClose()
                        onRefresh && onRefresh()
                    }
                }
            })
        )
    }

    handlerClose = () => {
        const { onClose } = this.props
        if (!this.bChanged()) {
            onClose && onClose()
            return
        }
        Tyan.pubForm.showConfirm('确定要放弃更改吗？', onClose)
    }

    canSave = () => {
        return this.bChanged() && !Tyan.checkForm.checkLimited(this)
    }

    bChanged = () => {
        return hasChangedValues(this)
    }


    fieldset基本信息 = () => {
        const 点检类别 = getFormValue(this, '基本信息', '点检类别')
        const bInputPara = ['单选', '下拉选择'].includes(getFormValue(this, '基本信息', '输入方式'))

        return [
            { _text: '项目名称', required: true, },
            { _radio: '点检类别', required: true, },
            { _radio: '点检频率', required: true, cdt: () => 点检类别 == '日常自动', },
            { _radio: '输入方式', required: true, },
            { _text: '选项', required: bInputPara, cdt: () => bInputPara, },
            { _radio: '是否拍照', required: true, },
            { _text: '点检说明', maxRows: 5 },
        ]
    }

    render() {
        const { showMessage: Message, showBody: Body } = this.props
        const { id, readOnly, initValues基本信息 } = this.state
        if (!initValues基本信息) return <Message text={'请稍等 ...'} />

        return <Body data={this} maxWidth={600}
            controls={
                readOnly ? [{ _button: '关闭', handler: this.handlerClose }] :
                    [
                        { _button: '保存', handler: this.handlerSave, disabled: !this.canSave() },
                        { _button: '删除', handler: this.handlerDelete, cdt: () => id > 0 },
                        { _button: this.bChanged() && '取消' || '关闭', handler: this.handlerClose },
                    ]}
            fieldsets={
                [
                    { title: '', name: '基本信息', _fieldset: this.fieldset基本信息(), disabled: readOnly },
                ]}
        />
    }
}

export default SpotItemSettingDiv